package com.macrofocus.eflux.network.line

import com.macrofocus.eflux.network.CombinedBranches
import com.macrofocus.eflux.network.logical.LogicalBranchId
import org.molap.dataframe.ListDataFrameBuilder
import org.molap.dataframe.MapDataFrameBuilder

class Line(
    val logicalBranchId: LogicalBranchId, val branches: CombinedBranches?,
    powerLineData: PowerLineData,
    geometryData: GeometryLineData,
    riskLineData: RiskLineData,
    weatherLineData: WeatherLineData
) :
    PowerLineData by powerLineData,
    GeometryLineData by geometryData,
    RiskLineData by riskLineData,
    WeatherLineData by weatherLineData {
    val from = logicalBranchId.from
    val to = logicalBranchId.to

    override fun toString(): String = logicalBranchId.toString()

    companion object {
        val dataFrameBuilder: ListDataFrameBuilder<Line, String>.() -> Unit = {
            "logicalBranchId" to { logicalBranchId }
            "name" to { longName }
            "from" to { from }
            "to" to { to }
            "dp" to { dp }
            "ratea" to { ratea }
            "pratea" to { pratea }
            "probability" to { probability }
            "riskMap" to { riskMap }
            "riskList" to { riskList }
            "assetCount" to { assetCount }
//            "details" to { details }
            "mint70m" to { mint70m }
            "maxt70m" to { maxt70m }
            "wind_speed_70m_min" to { wind_speed_70m_min }
            "wind_speed_70m_max" to { wind_speed_70m_max }
            "wind_gusts_70m_1h_min" to { wind_gusts_70m_1h_min }
            "wind_gusts_70m_1h_max" to { wind_gusts_70m_1h_max }
            "precip_5min_min" to { precip_5min_min }
            "precip_5min_max" to { precip_5min_max }
            "precip_type_intensity_5min_min" to { precip_type_intensity_5min_min }
            "precip_type_intensity_5min_max" to { precip_type_intensity_5min_max }
            "power_line_oscillation_24h_min" to { power_line_oscillation_24h_min }
            "power_line_oscillation_24h_max" to { power_line_oscillation_24h_max }
            "weather_code_1h_min" to { weather_code_1h_min }
            "weather_code_1h_max" to { weather_code_1h_max }
            "tstorm_warning_1h_min" to { tstorm_warning_1h_min }
            "tstorm_warning_1h_max" to { tstorm_warning_1h_max }
            "air_density_70m_min" to { air_density_70m_min }
            "air_density_70m_max" to { air_density_70m_max }
        }

        val mapDataFrameBuilder: MapDataFrameBuilder<LogicalBranchId, Line, String>.() -> Unit = {
            "logicalBranchId" to { logicalBranchId }
            "name" to { longName }
            "from" to { from }
            "to" to { to }
            "dp" to { dp }
            "ratea" to { ratea }
            "pratea" to { pratea }
            "probability" to { probability }
            "riskMap" to { riskMap }
            "riskList" to { riskList }
            "assetCount" to { assetCount }
//            "details" to { details }
            "mint70m" to { mint70m }
            "maxt70m" to { maxt70m }
            "wind_speed_70m_min" to { wind_speed_70m_min }
            "wind_speed_70m_max" to { wind_speed_70m_max }
            "wind_gusts_70m_1h_min" to { wind_gusts_70m_1h_min }
            "wind_gusts_70m_1h_max" to { wind_gusts_70m_1h_max }
            "precip_5min_min" to { precip_5min_min }
            "precip_5min_max" to { precip_5min_max }
            "precip_type_intensity_5min_min" to { precip_type_intensity_5min_min }
            "precip_type_intensity_5min_max" to { precip_type_intensity_5min_max }
            "power_line_oscillation_24h_min" to { power_line_oscillation_24h_min }
            "power_line_oscillation_24h_max" to { power_line_oscillation_24h_max }
            "weather_code_1h_min" to { weather_code_1h_min }
            "weather_code_1h_max" to { weather_code_1h_max }
            "tstorm_warning_1h_min" to { tstorm_warning_1h_min }
            "tstorm_warning_1h_max" to { tstorm_warning_1h_max }
            "air_density_70m_min" to { air_density_70m_min }
            "air_density_70m_max" to { air_density_70m_max }
        }
    }
}